import BaseModel from './BaseModel';

class Scheme extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.cust_scheme_validity_limit = data.cust_scheme_validity_limit || "";
    this.earnings = data.earnings || "";
    this.description = data.description || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      scheme: {
        name: this.name,
        cust_scheme_validity_limit: this.cust_scheme_validity_limit,
        earnings: this.earnings,
        description: this.description,
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field] === "") {
          this.errors.name = "Scheme name cannot be blank.";
        } else {
          delete this.errors.name;
        }
      },
      cust_scheme_validity_limit: () => {
        if(this[field] === "") {
          this.errors.cust_scheme_validity_limit = "Scheme validity limit cannot be blank.";
        } else {
          delete this.errors.cust_scheme_validity_limit;
        }
      },
      earnings: () => {
        if(this[field] === "") {
          this.errors.earnings = "Earnings cannot be blank.";
        } else {
          delete this.errors.earnings;
        }
      },
      description: () => {
        if(this[field] === "") {
          this.errors.description = "Description cannot be blank.";
        } else {
          delete this.errors.description;
        }
      },
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }

}

export default Scheme;
